import { z } from 'zod';

const setEntrySchema = z.object({
  a: z.number().int().min(0).max(99),
  b: z.number().int().min(0).max(99),
  tiebreak: z
    .object({
      a: z.number().int().min(0).max(99),
      b: z.number().int().min(0).max(99),
    })
    .optional(),
});

export const teamScoreResultSchema = z.object({
  mode: z.literal('team_score'),
  A: z.number().int().min(0).max(999),
  B: z.number().int().min(0).max(999),
});

export const setsResultSchema = z.object({
  mode: z.literal('sets'),
  sets: z.array(setEntrySchema).min(1).max(7),
});

export const activityScoresSchema = z.discriminatedUnion('mode', [
  teamScoreResultSchema,
  setsResultSchema,
]);
